export default __webpack_public_path__ + "static/media/LindeDaxRegWeb.873396c2.woff";